import { render, staticRenderFns } from "./MessageSelect.vue?vue&type=template&id=4a171ada&scoped=true&"
import script from "./MessageSelect.vue?vue&type=script&lang=js&"
export * from "./MessageSelect.vue?vue&type=script&lang=js&"
import style0 from "./MessageSelect.vue?vue&type=style&index=0&id=4a171ada&prod&scoped=true&lang=css&"
import style1 from "./MessageSelect.vue?vue&type=style&index=1&id=4a171ada&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a171ada",
  null
  
)

export default component.exports